var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h4", [_vm._v("Запись будет скрыта по причине отсутствия поставщика")]),
    _vm._v(" "),
    _c("div", { staticClass: "input-group" }, [
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.addDelay,
              expression: "addDelay",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.addDelay)
              ? _vm._i(_vm.addDelay, null) > -1
              : _vm.addDelay,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.addDelay,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.addDelay = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.addDelay = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.addDelay = $$c
              }
            },
          },
        }),
        _vm._v(" активировать запись через некоторое время\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        !_vm.addDelay
          ? [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comment,
                    expression: "comment",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: "Комментарий", rows: "2" },
                domProps: { value: _vm.comment },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.comment = $event.target.value
                  },
                },
              }),
            ]
          : [
              _c("ShiftTaskActualDate", {
                ref: "ShiftTaskActualDate",
                attrs: { plusDays: "60" },
              }),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }